import { Icon } from '@fattureincloud/fic-design-system'
import styled, { css } from 'styled-components'

import backgroundImage from '../../assets/img/background-faq.png'
import FICColors from '../../common/FICColors'

export const Logo = styled.img`
  position: absolute;
  top: 30px;
  left: 34px;
  z-index: 9999;
  height: 32px;
`

export const DefaultExternalTitle = styled.h1<{ isResellers: boolean }>`
  position: absolute;
  margin: 0;
  line-height: inherit;
  left: ${(props) => (props.isResellers ? '300px' : '130px')};
  top: 34px;
  height: 28px;

  color: ${FICColors.white};
  font-size: 20px;
  font-weight: 400;
  border-left: 2px solid rgba(255, 255, 255, 0.5);
  padding-left: 24px;
  margin-left: 24px;
  padding-top: 5px;
  box-sizing: border-box;
  @media screen and (max-width: 799px) {
    position: relative;
    display: inline-block;
    left: unset;
  }
  @media (max-width: 425px) {
    font-size: 16px;
    line-height: 27px;
    height: 32px;
    padding-left: 16px;
    margin-left: 16px;
    padding-top: 2px;
  }
`

export const IconClose = styled(Icon)`
  height: 40px;
  cursor: pointer;
  position: absolute;
  top: 30px;
  right: 34px;
  color: ${FICColors.white};
  opacity: 1;
  z-index: 9999;
`

export const TopHeaderContainer = styled.div`
  margin:0;
  -webkit-font-smoothing: antialiased;
  font-family: 'Open Sans', sans-serif;
  a{
    color: #0D97D5;
  }
  ul{
    padding: 0;
    margin: 0 0 10px 25px;
  }
  top: 0;
  width: 100%;
  z-index: 101;
  background-color: ${FICColors.white};
  color: ${FICColors.textDefault};
  border-bottom: 1px solid rgba(51, 51, 51, 0.08);
  box-sizing: border-box;
  //position: absolute;
  overflow: hidden;
  .headerContainer {
    max-width: 1200px;
    margin: 0 auto;
    position: relative;
    padding: 23px 0;
    box-sizing: border-box;
    height: 100%;
    @media screen and (max-width: 799px) {
      text-align: center;
    }
    @media (max-width: 425px) {
      padding: 10px 0;
      img {
        height: 28px;
      }
    }
  }
  .logo {
    display: inline-block;
    margin-top: 5px;
    cursor: pointer;
  }
  .defaultTitle {
    margin: 0;
    display: inline-block;
    height: 33px;
    font-size: 20px;
    font-weight: 400;
    border-left: 2px solid rgba(0, 0, 0, 0.3);
    padding-left: 24px;
    margin-left: 24px;
    padding-top: 6px;
    vertical-align: top;
    box-sizing: border-box;
    margin-top: 5px;
    color: rgba(51, 51, 51, 0.8);
    @media (max-width: 425px) {
      font-size: 16px;
      line-height: 27px;
      height: 32px;
      padding-left: 16px;
      margin-left: 16px;
      padding-top: 2px;
    }
  }
`

export const HeaderContainer = styled.div`
  color: ${FICColors.white};
  position: relative;
  background: url('${backgroundImage}');
`

export const HeaderDetailedContainer = styled.div`
  color: ${FICColors.white};
  position: relative;
  padding-bottom: 50px;
  min-height: 190px;
  box-sizing: border-box;
  background: url('${backgroundImage}');
  @media (max-width: 425px) {
    padding-bottom: 25px;
    min-height: 80px;
  }
  .sectionHeader {
    margin: 0 auto;
    padding-top: 25px;
    position: relative;
    max-width: 940px;
    h1 {
      margin: 0;
      color: ${FICColors.white};
      font-size: 34px;
      font-weight: bold;
      line-height: 48px;
      margin-top: 17px;
    }
    @media (max-width: 425px) {
      h1 {
        font-size: 20px;
        line-height: 30px;
        margin: 0;
      }
      h4 {
        font-size: 16px;
        line-height: 27px;
        margin-bottom: 0;
      }
    }
  }
  .embeddedHeader {
    max-width: 800px;
  }
  .description {
    color: ${FICColors.white};
    margin: 0;
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;
    margin-top: 5px;
  }
`

export const FBCommunityBannerContainer = styled.div<{ isVisible: boolean }>`
  background-color: ${FICColors.lightGray};
  color: ${FICColors.textDefault};
  top: 0;
  z-index: 102;
  width: 100%;
  transition: max-height 500ms;
  max-height: 0;
  overflow: hidden;
  ${(props) =>
    props.isVisible &&
    css`
      max-height: 200px;
    `}
  >div {
    max-width: 1080px;
    font-size: 14px;
    line-height: 24px;
    display: flex;
    align-items: center;
    margin: 0 auto;
    padding: 12px;

    @media (max-width: 425px) {
      align-items: start;
    }

    img {
      display: block;
      height: 16px;
      margin-right: 12px;
    }
    span {
      flex: 1;
    }
    a {
      color: rgb(13, 151, 213);
      cursor: pointer;
      text-decoration: none;
    }
    .Icon {
      cursor: pointer;
      margin-left: 12px;
      justify-self: right;
    }
  }
`

export const SearchSectionContainer = styled.div`
  text-align: center;
  padding-bottom: 50px;
  .fic-page-section-block {
    max-width: 100%;

    h1 {
      height: 24px;
      color: rgba(255, 255, 255, 0.8);
      font-size: 20px;
      font-weight: 600;
      letter-spacing: 0.11px;
      line-height: 24px;
      margin-bottom: 60px;
      margin-top: 35px;
    }
  }
  .subtitle {
    height: 48px;
    @media screen and (max-width: 799px) {
      height: auto;
    }
    color: ${FICColors.white};
    font-size: 32px;
    font-weight: bold;
    letter-spacing: 0.17px;
    line-height: 48px;
    text-align: center;
    @media (max-width: 425px) {
      font-size: 20px;
      line-height: 30px;
    }
  }
`

export const AccessButtons = styled.div`
  float: right;
  display: flex;

  @media screen and (max-width: 799px) {
    display: none;
  }
`
